module.exports = "../../assets/images/user-profile.950331c8.png";